import menuItemsApi from "@/api/menuItems";
const state = {
    isLoading: false,
    validationErrors: null,
    menuItems: [],
    childMenuItems: [],
    siblingsItems: []
};

export const mutationTypes = {
    loadMenuItemsStart: "[menuItems] loadMenuItemsStart",
    loadMenuItemsSuccess: "[menuItems] loadMenuItemsSuccess",
    loadMenuItemsFailure: "[menuItems] loadMenuItemsFailure",

    getChildMenuItemsByParentStart: "[menuItems] getChildMenuItemsByParentStart",
    getChildMenuItemsByParentSuccess: "[menuItems] getChildMenuItemsByParentSuccess",
    getChildMenuItemsByParentFailure: "[menuItems] getChildMenuItemsByParentFailure",

    getSiblingsByToStart: "[menuItems] getSiblingsByToStart",
    getSiblingsByToSuccess: "[menuItems] getSiblingsByToSuccess",
    getSiblingsByToFailure: "[menuItems] getSiblingsByToFailure",
};

export const actionTypes = {
    loadMenuItems: "[menuItems] loadMenuItems",
    getChildMenuItemsByParent: "[menuItems] getChildMenuItemsByParent",
    getSiblingsByTo: "[menuItems] getSiblingsByTo"
};

const mutations = {
    [mutationTypes.loadMenuItemsStart](state) {
        state.isLoading = true;
        state.error = null;
    },
    [mutationTypes.loadMenuItemsSuccess](state, items) {
        state.isLoading = false;
        state.menuItems = items;
    },
    [mutationTypes.loadMenuItemsFailure](state, error) {
        state.isLoading = false;
        state.error = error;
    },


    [mutationTypes.getChildMenuItemsByParentStart](state) {
        state.isLoading = true;
        state.error = null;
    },
    [mutationTypes.getChildMenuItemsByParentSuccess](state, items) {
        state.isLoading = false;
        state.childMenuItems = items;
    },
    [mutationTypes.getChildMenuItemsByParentFailure](state, error) {
        state.isLoading = false;
        state.error = error;
    },

    [mutationTypes.getSiblingsByToStart](state) {
        state.isLoading = true;
        state.error = null;
        state.siblingsItems = [];
    },
    [mutationTypes.getSiblingsByToSuccess](state, items) {
        state.isLoading = false;
        state.siblingsItems = items;
    },
    [mutationTypes.getSiblingsByToFailure](state, error) {
        state.isLoading = false;
        state.error = error;
        state.siblingsItems = [];
    },
};

const actions = {
    async [actionTypes.loadMenuItems]({ commit }) {
        commit(mutationTypes.loadMenuItemsStart);
        try {
            const response = await menuItemsApi.getMenuItems();
            if (response.data.status === "SUCCESS") {
                commit(mutationTypes.loadMenuItemsSuccess, response.data.result);
            } else {
                commit(mutationTypes.loadMenuItemsFailure, response.data.message);
            }
        } catch (error) {
            commit(mutationTypes.loadMenuItemsFailure, error);
            console.error("Ошибка при запросе меню", error);
        }
    },

    async [actionTypes.getChildMenuItemsByParent]({ commit}, parentId) {
        commit(mutationTypes.getChildMenuItemsByParentStart);
        try {
            const response = await menuItemsApi.getChildByParent(parentId);
            if (response.data.status === "SUCCESS") {
                commit(mutationTypes.getChildMenuItemsByParentSuccess, response.data.result);
            } else {
                commit(mutationTypes.getChildMenuItemsByParentFailure, response.data.message);
            }
        } catch (error) {
            commit(mutationTypes.getChildMenuItemsByParentFailure, error);
            console.error("Ошибка при запросе меню", error);
        }
    },

    async [actionTypes.getSiblingsByTo]({ commit }, { to, label = null }) {
        commit(mutationTypes.getSiblingsByToStart);
        try {

            const response = await menuItemsApi.getSiblingsByTo(to, label);

            if (response.data.status === "SUCCESS") {
                commit(mutationTypes.getSiblingsByToSuccess, response.data.result);
            } else {
                commit(mutationTypes.getSiblingsByToFailure, response.data.message);
            }
        } catch (error) {
            commit(mutationTypes.getSiblingsByToFailure, error);
            console.error("Ошибка при получении siblings по to:", error);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
